import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import { 
  CustomGradingScale, 
  CreateCustomGradingScaleInput 
} from "@/types/dashboard.types";
import { toast } from "sonner";

 
export const customGradingScaleKeys = {
  all: ["customGradingScales"] as const,
  user: (userId: string) => [...customGradingScaleKeys.all, "user", userId] as const,
};

 
export const useCustomGradingScales = (userId: string | null) => {
  console.log("useCustomGradingScales hook called with userId:", userId);
  
  return useQuery({
    queryKey: customGradingScaleKeys.user(userId || ""),
    queryFn: async () => {
      console.log("useCustomGradingScales queryFn executing with userId:", userId);
      
      if (!userId) {
        console.log("No userId provided, returning empty array");
        return [];
      }
      try {
        console.log("Making API call to fetch custom grading scales for userId:", userId);
        const response = await api.get<CustomGradingScale[]>(`/api/grading-scales/user/${userId}`);
        console.log("API response received:", response.data);
        return response.data;
      } catch (error) {
        console.error("Failed to fetch custom grading scales:", error);
        return [];
      }
    },
    enabled: !!userId,
  });
};

 
export const useCreateCustomGradingScale = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async ({ userId, data }: { userId: string; data: CreateCustomGradingScaleInput }) => {
      try {
        const response = await api.post<CustomGradingScale>(`/api/grading-scales/user/${userId}`, data);
        
        if (response.status !== 201) {
          throw new Error("Failed to create custom grading scale");
        }
        
        return response.data;
      } catch (error) {
        console.error("Failed to create custom grading scale:", error);
        throw error;
      }
    },
    onSuccess: ( { userId }) => {
      toast.success("Custom grading scale created successfully!");
      
       queryClient.invalidateQueries({
        queryKey: customGradingScaleKeys.user(userId),
      });
    },
    onError: (error: any) => {
      const errorMessage = error.response?.data?.error || error.message || "Failed to create custom grading scale";
      toast.error(errorMessage);
    },
  });
}; 